
@file:Suppress("unused")
package tk.mallumo.compose.navigation


import tk.mallumo.compose.navigation.ArgumentsNavigation


fun one.devsbox.www.tools.ArgsId.fill(bundle: ArgumentsNavigation): one.devsbox.www.tools.ArgsId {
	id = bundle.long["id", id]
	return this
}
fun one.devsbox.www.tools.ArgsId.asBundle() = ArgumentsNavigation().apply{
	this.long["id"] = this@asBundle.id
}
fun one.devsbox.www.tools.ArgsIdWithParent.fill(bundle: ArgumentsNavigation): one.devsbox.www.tools.ArgsIdWithParent {
	id = bundle.long["id", id]
	parentId = bundle.long["parentId", parentId]
	return this
}
fun one.devsbox.www.tools.ArgsIdWithParent.asBundle() = ArgumentsNavigation().apply{
	this.long["id"] = this@asBundle.id
	this.long["parentId"] = this@asBundle.parentId
}
fun one.devsbox.www.ui.resources.ArgsListingResource.fill(bundle: ArgumentsNavigation): one.devsbox.www.ui.resources.ArgsListingResource {
	pickerModeKey = bundle.string["pickerModeKey", pickerModeKey]
	return this
}
fun one.devsbox.www.ui.resources.ArgsListingResource.asBundle() = ArgumentsNavigation().apply{
	this.string["pickerModeKey"] = this@asBundle.pickerModeKey
}
fun one.devsbox.www.ui.uploader.UploaderArgs.fill(bundle: ArgumentsNavigation): one.devsbox.www.ui.uploader.UploaderArgs {
	enabledTypes = bundle.int["enabledTypes", enabledTypes]
	return this
}
fun one.devsbox.www.ui.uploader.UploaderArgs.asBundle() = ArgumentsNavigation().apply{
	this.int["enabledTypes"] = this@asBundle.enabledTypes
}
